module.exports = __webpack_public_path__ + "images/emails/i-twitter-6a31527e.gif";